import type { PageVariable, Source, VariableValues } from '@/types'

export const variableRef = /\$\{([A-Za-z_][A-Za-z0-9_]*)\}|\$([A-Za-z_][A-Za-z0-9_]*)/

export const usesVariables = (source: Source | null | undefined): boolean =>
  !!source && variableRef.test(JSON.stringify(source.config ?? {}))

export const defaultValues = (variables: PageVariable[]): VariableValues => {
  const out: VariableValues = {}
  for (const v of variables) {
    const d = v.default
    if (Array.isArray(d)) out[v.name] = d.filter(x => typeof x === 'string' && x !== '')
    else if (typeof d === 'string' && d !== '') out[v.name] = [d]
    else if (v.kind === 'interval' && v.options?.length) out[v.name] = [v.options[0]]
    else out[v.name] = []
  }
  return out
}

export const intervalStep = (variables: PageVariable[], values: VariableValues): string | undefined => {
  for (const v of variables) {
    if (v.kind !== 'interval') continue
    const picked = values[v.name]?.[0]
    if (picked && /^\d+(ms|s|m|h)$/.test(picked)) return picked
  }
  return undefined
}

export const variableLabel = (v: PageVariable): string => v.label?.trim() || v.name
